import React from 'react';

import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
//import 'bootstrap/dist/css/bootstrap.min.css';

export default function CustomToast({id, title, body, handleClose, show, logo, autohide, classNames}) {

    return (
        <ToastContainer className={classNames} position="top-end">
            <Toast id={id} show={show} onClose={handleClose} delay={3000} autohide={autohide}>
                <Toast.Header>
                    <img
                        alt=""
                        src={logo}
                        width="30"
                        height="30"
                        className="d-inline-block align-top"
                        />
                    {title}
                </Toast.Header>
                <Toast.Body>{body}</Toast.Body>
            </Toast>
        </ToastContainer>
    );
}